var map = {
	"./AdminButtons": 58,
	"./AdminButtons.js": 58,
	"./ArrangeASentence": 74,
	"./ArrangeASentence.js": 74,
	"./Audio": 59,
	"./Audio.js": 59,
	"./AudioPlayer": 19,
	"./AudioPlayer.js": 19,
	"./BackToLessonButton": 104,
	"./BackToLessonButton.js": 104,
	"./BlanksGrid": 75,
	"./BlanksGrid.js": 75,
	"./Comment": 61,
	"./Comment.js": 61,
	"./CommentContext": 44,
	"./CommentContext.js": 44,
	"./CommentList": 105,
	"./CommentList.js": 105,
	"./CopycatQuiz": 62,
	"./CopycatQuiz.js": 62,
	"./Dialog": 106,
	"./Dialog.js": 106,
	"./Errors": 12,
	"./Errors.js": 12,
	"./ExampleModal": 107,
	"./ExampleModal.js": 107,
	"./Exercise": 108,
	"./Exercise.js": 108,
	"./Feedback": 24,
	"./Feedback.js": 24,
	"./FetchList": 109,
	"./FetchList.js": 109,
	"./FillInTheBlank": 67,
	"./FillInTheBlank.js": 67,
	"./FindTheMistake": 68,
	"./FindTheMistake.js": 68,
	"./Flashcard": 76,
	"./Flashcard.js": 76,
	"./FreeTextQuestion": 39,
	"./FreeTextQuestion.js": 39,
	"./Image": 27,
	"./Image.js": 27,
	"./Loading": 110,
	"./Loading.js": 110,
	"./MatchImageAndText": 71,
	"./MatchImageAndText.js": 71,
	"./MatchImageAndText_DEP": 111,
	"./MatchImageAndText_DEP.js": 111,
	"./Maze": 69,
	"./Maze.js": 69,
	"./MazeForm": 112,
	"./MazeForm.js": 112,
	"./Modal": 21,
	"./Modal.js": 21,
	"./MultipleChoiceQuestion": 66,
	"./MultipleChoiceQuestion.js": 66,
	"./MyAudioRecorder": 35,
	"./MyAudioRecorder.js": 35,
	"./MyContext": 9,
	"./MyContext.js": 9,
	"./MyTextInputAndSubmit": 113,
	"./MyTextInputAndSubmit.js": 113,
	"./NewComment": 83,
	"./NewComment.js": 83,
	"./NextButton": 7,
	"./NextButton.js": 7,
	"./NextExerciseButton": 63,
	"./NextExerciseButton.js": 63,
	"./NumberLabel": 26,
	"./NumberLabel.js": 26,
	"./OldMaze": 70,
	"./OldMaze.js": 70,
	"./OptionButton": 46,
	"./OptionButton.js": 46,
	"./PreviousQuestionButton": 28,
	"./PreviousQuestionButton.js": 28,
	"./Progress": 36,
	"./Progress.js": 36,
	"./Quiz": 65,
	"./Quiz.js": 65,
	"./RevealAnswer": 25,
	"./RevealAnswer.js": 25,
	"./RevealClue": 60,
	"./RevealClue.js": 60,
	"./RevealFindTheMistake": 114,
	"./RevealFindTheMistake.js": 114,
	"./RevealMatchAnswer": 72,
	"./RevealMatchAnswer.js": 72,
	"./RichTextContainer": 38,
	"./RichTextContainer.js": 38,
	"./SetMistakesField": 115,
	"./SetMistakesField.js": 115,
	"./SpecialCharactersModal": 31,
	"./SpecialCharactersModal.js": 31,
	"./SubmitButton": 45,
	"./SubmitButton.js": 45,
	"./TextBlanksField": 116,
	"./TextBlanksField.js": 116,
	"./TextExercise": 73,
	"./TextExercise.js": 73,
	"./UserNamesFields": 117,
	"./UserNamesFields.js": 117,
	"./Video": 118,
	"./Video.js": 118,
	"./fadeInOutWhileSettingState": 64,
	"./fadeInOutWhileSettingState.js": 64,
	"./isLast": 33,
	"./isLast.js": 33,
	"./mergeSolutions": 29,
	"./mergeSolutions.js": 29,
	"./nextButtonText": 22,
	"./nextButtonText.js": 22,
	"./parseForInvalidCharacters": 47,
	"./parseForInvalidCharacters.js": 47,
	"./phones": 147,
	"./phones.png": 147,
	"./redirectToExerciseOrLesson": 20,
	"./redirectToExerciseOrLesson.js": 20,
	"./setSquare": 148,
	"./setSquare.js": 148
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 161;